import {
  weekSection,
  adjacentSection,
  berlinDay,
  calendarDate,
} from "./gamesCalendar";
export const priceAt = (fixture, pointer) =>
  typeof pointer === "string" && pointer.startsWith("/")
    ? pointer
        .split("/")
        .slice(1)
        .reduce(
          (v, k) => v?.[k.replaceAll("~1", "/").replaceAll("~0", "~")],
          fixture
        )
    : null;
export const sectionLabel = (range) => `KW ${range.week}${range.section}`;
export function exportSections(data) {
  const date = new Date(data?.generated_at);
  if (!Number.isFinite(date.getTime())) return [];
  const current = weekSection(calendarDate(berlinDay(date)));
  return [current, adjacentSection(current, 1)].map(sectionLabel);
}
export function marketGroup(tip) {
  return tip.market === "over-under"
    ? Number(tip.line) === 2.5
      ? "over-under-2.5"
      : "goal-lines"
    : tip.market || "other";
}
export const marketLabels = {
  "1x2": "1X2",
  "over-under-2.5": "Over/Under 2.5",
  "goal-lines": "Over/Under · Goal Lines",
  "asian-handicap": "Asian Handicap",
  btts: "BTTS",
  "correct-score": "Correct Score",
  "double-chance": "Double Chance",
};
export function exportRows(data) {
  return (data?.leagues || []).flatMap((league) =>
    (league.fixtures || []).flatMap((fixture) =>
      (fixture.indications || []).map((tip, index) => {
        const date = new Date(fixture.kickoff);
        const probability =
          tip.probability ??
          (tip.market === "1x2"
            ? fixture.model?.probabilities?.[
                { 1: "homewin", X: "draw", 2: "awaywin" }[tip.selection]
              ]
            : null);
        return {
          ...tip,
          id: `${league.league_id}:${fixture.fixture_id}:${index}`,
          fixture,
          league,
          probability,
          fair: priceAt(fixture, tip.fair_price_ref),
          quote: priceAt(fixture, tip.market_price_ref),
          group: marketGroup(tip),
          section: Number.isFinite(date.getTime())
            ? sectionLabel(weekSection(calendarDate(berlinDay(date))))
            : null,
        };
      })
    )
  );
}
export function filterRows(
  rows,
  { league = "", market = "", section = "", search = "", sort = "date" } = {}
) {
  return rows
    .filter(
      (r) =>
        (!league || String(r.league.league_id) === league) &&
        (!market || r.group === market) &&
        (!section || r.section === section) &&
        (!search ||
          `${r.fixture.home_team?.name || ""} ${
            r.fixture.away_team?.name || ""
          }`
            .toLowerCase()
            .includes(search.toLowerCase()))
    )
    .sort(
      (a, b) =>
        (sort === "value"
          ? (Number.isFinite(b.value) ? b.value : -Infinity) -
            (Number.isFinite(a.value) ? a.value : -Infinity)
          : sort === "league"
          ? (a.league.league_name || "").localeCompare(
              b.league.league_name || ""
            )
          : 0) ||
        (Date.parse(a.fixture.kickoff) || 0) -
          (Date.parse(b.fixture.kickoff) || 0)
    );
}
export function exportSummary(data) {
  const fixtures = (data?.leagues || []).flatMap((l) => l.fixtures || []);
  const count = (d) =>
    fixtures.filter((f) => f.compilation_audit?.decision === d).length;
  return {
    leagues: data?.leagues?.length || 0,
    fixtures: fixtures.length,
    tips: exportRows(data).length,
    reused: count("reuse"),
    computed: fixtures.filter((f) => f.compilation_audit?.compiled === true)
      .length,
    problematic: count("problem"),
    unknown: fixtures.filter((f) => !f.compilation_audit).length,
  };
}
